var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.active === true)?_c('component-import-study',{attrs:{"permissions":_vm.permissions,"album-i-d":_vm.albumID}}):_vm._e(),(_vm.active === false)?_c('div',[_c('b-card',{staticClass:"text-center"},[_c('div',{staticClass:"bg-secondary font-large"},[_vm._v(" "+_vm._s(_vm.$t('invalidtoken'))+" ")])])],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }